<template>
  <SideModal
    v-if="showVestingInfo"
    class="tw-z-20"
    :showBackButton="showBackButton"
    @close="closeVestingInfo"
    :title="title"
    @go-back="goBack"
  >
    <template v-slot:content>
      <VestingInfoForm
        v-if="form === 'vestingInfo'"
        :employee="employee"
        :status="status"
        :vestingSchedule="vestingSchedule"
        :vestingFrequency="vestingFrequency"
        :marketPrice="marketPrice"
        @top-up="switchForm"
        @reload-data="$emit('reload-data')"
      />
      <TopUpForm v-if="form === 'topUp'" :esopToken="esopToken" />
    </template>
  </SideModal>
</template>

<script setup>
  import SideModal from "@/components/general/sidemodal/SideModal";
  import TopUpForm from "@/components/employeesBenefit/forms/TopUpForm";
  import VestingInfoForm from "@/components/employeesBenefit/forms/VestingInfoForm";
  import { computed, ref } from "vue";
  import { useStore } from "vuex";

  const props = defineProps({
    showVestingInfo: {
      type: Boolean,
      required: true,
    },
    employee: {
      type: Object,
      required: true,
    },
  });
  const emits = defineEmits(["close"]);

  const store = useStore();

  const form = ref("vestingInfo");
  const title = ref("Vesting Info");
  const showBackButton = ref(false);

  const showVestingInfo = computed(() => props.showVestingInfo);
  const employee = computed(() => props.employee);
  const esopToken = computed(() => store.getters["Esop/esopToken"]);
  const marketPrice = computed(
    () => esopToken.value.valuation / esopToken.value.total_supply
  );

  const status = computed(() => {
    let status = null;
    const defaultStatus = employee.value?.status;
    if (defaultStatus) {
      switch (defaultStatus) {
        case "Accepted":
          status = "Contract Signed";
          break;
        default:
          status = employee.value?.status;
          break;
      }
    }
    return status;
  });
  const vestingSchedule = computed(() => {
    let vestedEsop = null;
    let vestedShares = employee.value?.employee?.vested_shares;
    let allocatedShares = employee.value?.employee?.allocated_shares;
    vestedEsop = vestedShares / allocatedShares;
    return vestedEsop;
  });
  const vestingFrequency = computed(() => {
    let frequency = null;
    switch (Number(employee.value.vesting_frequency)) {
      case 1:
        frequency = "Daily";
        break;
      case 30:
        frequency = "Monthly";
        break;
      case 91:
        frequency = "Quarterly";
      case 182:
        frequency = "Bi-annually";
      case 365:
        frequency = "Yearly";
        break;
    }
    return frequency;
  });

  const switchForm = (form) => {
    switch (form) {
      case "vestingInfo":
        form.value = "topUp";
        title.value = "Top up shares";
        showBackButton.value = true;
        break;

      default:
        break;
    }
  };
  const goBack = () => {
    switch (form.value) {
      case "topUp":
        form.value = "vestingInfo";
        title.value = "Vesting Info";
        showBackButton.value = false;
        break;

      default:
        break;
    }
  };
  const closeVestingInfo = () => {
    form.value = "vestingInfo";
    title.value = "Vesting Info";
    showBackButton.value = false;
    emits("close");
  };
</script>

<style lang="scss" scoped></style>
